/* eslint-disable tailwindcss/no-arbitrary-value */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import classNames from 'classnames';
import { MaterialIcon } from '../../../components/MaterialIcon';

export const TableRuleButton = (props: {
  type: 'left' | 'right';
  onClick: () => void;
  show: boolean;
}) => {
  const icon = props.type === 'right' ? 'arrow_right_alt' : 'arrow_left_alt';
  const right = props.type === 'right' ? -15 : undefined;
  const left = props.type === 'left' ? -15 : undefined;
  return (
    <div
      data-component="ComparisonTableRuleButton"
      data-type={props.type}
      className={classNames(
        'absolute z-[45] size-[30px] cursor-pointer',
        'items-center justify-center rounded-full shadow-md bg-white',
        {
          hidden: !props.show,
          flex: props.show,
        },
      )}
      onClick={props.onClick}
      style={{
        right,
        left,
        top: 'calc(((100% - 72px) / 2) + 72px - 15px)',
      }}
    >
      <MaterialIcon icon={icon} px={18} className="text-black" />
    </div>
  );
};
